export const toggleSort = (
  colID,
  colNum,
  key,
  data,
  setData,
  order,
  setOrder
) => {
  var theColumn = document.getElementById(colID);
  var sortedTDs = document.querySelectorAll(
    "td:nth-child(" + colNum + "), *[role=cell]:nth-child(" + colNum + ")"
  );
  var currSort = theColumn.getAttribute("aria-sort");
  if (currSort == "descending") {
    clearSorts();
    theColumn.setAttribute("aria-sort", "ascending");
  } else {
    clearSorts();
    theColumn.setAttribute("aria-sort", "descending");
  }
  for (var i = 0; i < sortedTDs.length; i++) {
    sortedTDs[i].classList.add("sorted");
  }

  let sortedData = [...data].sort((a, b) => {
    if (order === "asc") {
      return a[key] > b[key] ? 1 : -1;
    } else {
      return a[key] < b[key] ? 1 : -1;
    }
  });

  setData(sortedData);
  setOrder(order === "asc" ? "desc" : "asc");
};

export const clearSorts = () => {
  var thSort = document.querySelectorAll("*[aria-sort]");
  var tdSort = document.querySelectorAll(".sorted");
  for (var i = 0; i < thSort.length; i++) {
    thSort[i].removeAttribute("aria-sort");
  }
  for (var i = 0; i < tdSort.length; i++) {
    tdSort[i].classList.remove("sorted");
  }
};

export const formatDate = (dateString) => { 
  const date = new Date(dateString);
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  return date.toLocaleDateString('EN-US', options); 
};

export const formatTime = (timeString) => { 
  if(timeString.indexOf('T') > -1){
    timeString = timeString.split('T')[1];
  }

  const [hours, minutes] = timeString.split(':');
  const date = new Date();
  date.setHours(hours);
  date.setMinutes(minutes);
  
  return date.toLocaleTimeString([], { hour: 'numeric', minute: 'numeric' }); 
};

export const timeConvert = (timeString, timeFormat) => {
  if(timeString.indexOf('T') > -1){
    timeString = timeString.split('T')[1];
  }
  if(!timeFormat){
    timeFormat = 'to24';
  }
  const input_Time = timeString;
  const select_Format = timeFormat;
  let output_Time = ''; 
  try {
    let hr, min, per;
    if (select_Format === 'to24') {
      [hr, min] = input_Time.split(':');
      hr = parseInt(hr, 10);
      min = parseInt(min, 10);
      if (isNaN(hr) || isNaN(min) ||
        hr < 0 || hr > 23 || min < 0 || min > 59) {
        console.log('Invalid time format');
      }
      if (hr === 12 && min === 0) {
        //output_Time = 'Time in 12 Hour Format is: 12:00 AM';
        output_Time = '12:00 PM';
      } else if (hr >= 12) {
        per = 'PM';
        if (hr > 12) {
          hr -= 12;
        }
        output_Time = `${hr.toString().padStart(2, '')}:${min.toString().padStart(2, '0')} ${per}`;
      } else {
        per = 'AM';
        if (hr === 0) {
          hr = 12;
        }
        output_Time = `${hr.toString().padStart(2, '')}:${min.toString().padStart(2, '0')} ${per}`;
      }
    } else if (select_Format === 'to12') {
      let [time, givenPeriod] = input_Time.split(' ');
      if (!time) {
        console.log('Invalid input format');
      }
      [hr, min] = time.split(':');
      hr = parseInt(hr, 10);
      min = parseInt(min, 10);
      if (isNaN(hr) || isNaN(min) || min < 0 || min > 59) {
        console.log('Invalid time format');
      }
      if (givenPeriod === 'AM' || givenPeriod === 'PM') {
        if (hr === 12) {
          hr = givenPeriod === 'AM' ? 0 : 12;
        } else if (givenPeriod === 'PM') {
          hr += 12;
        }
      } else {
        console.log('Invalid input format');
      }
      output_Time = `${hr.toString().padStart(2, '')}:${min.toString().padStart(2, '0')}`; 
    }
    return output_Time;
  } catch (err) {
    console.log('Invalid input. Please enter a valid time in the specified format.');
    output_Time = '';
  }  
}
